import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from '../defaultIconStyles.css';

export default function IconContainers({
    width = 20,
    height = 20,
    className = '',
    ...rest
}: IconProps) {
    return (
        <svg
            fillRule="evenodd"
            viewBox="0 0 20 20"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <title>Icon containers</title>
            <path
                d="M11.9004 8.1037C12.0724 8.27579 12.3113 8.38096 12.5788 8.38096H18.0446C18.5701 8.38096 19.0001 7.95072 19.0001 7.42488V1.95608C19.0001 1.43024 18.5701 1 18.0446 1H12.5788C12.3113 1 12.0724 1.10517 11.9004 1.27726C11.7284 1.44936 11.6233 1.68838 11.6233 1.95608V7.42488C11.6233 7.69258 11.7284 7.9316 11.9004 8.1037ZM13.5437 6.46879V2.92172H17.0888V6.46879H13.5437ZM8.60619 3.79829C9.13174 3.79829 9.56174 4.22853 9.56174 4.75437V10.4431H15.2473C15.7728 10.4431 16.2028 10.8733 16.2028 11.3991V18.0439C16.2028 18.5698 15.7728 19 15.2473 19H8.60619H1.95555C1.43 19 1 18.5698 1 18.0439V11.3991V4.75437C1 4.48667 1.10511 4.24765 1.27711 4.07555C1.44911 3.90346 1.688 3.79829 1.95555 3.79829H8.60619ZM9.56178 12.3648V17.0974H14.2822V12.3648H9.56178ZM2.92073 17.0974V12.3648H7.64116V17.0974H2.92073ZM2.92073 5.72003V10.4526H7.64116V5.72003H2.92073Z"
                className={css.colored}
            />
        </svg>
    );
}
